// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItems_meal__wgkJI","description":"MealItems_description__9_E5X","price":"MealItems_price__mHSSn"};